import { HttpClient } from '@angular/common/http';
import { CustomerCard } from './customer-card.types';
import { Injectable } from '@angular/core';

@Injectable()
export class CustomerCardService {
	private myCardsUrl = 'api/me/cards';
	private customerCardsUrl = (customerId: number) => `api/customers/${customerId}/cards`;
	private usUrl = (url: string) => `${url}/US`;

	constructor(private http: HttpClient) { }

	getCards(customerId?: number): Promise<CustomerCard[]> {
		const url = customerId ? this.customerCardsUrl(customerId) : this.myCardsUrl;

		return this.http.get<CustomerCard[]>(url).toPromise();
	}

	addCard(token: string, customerId?: number): Promise<void> {
		const options = {
			headers: {
				'Content-Type': 'application/json'
			}
		};
		const url = customerId ? this.customerCardsUrl(customerId) : this.myCardsUrl;

		return this.http.post<void>(url, JSON.stringify(token), options).toPromise();
	}

	deleteCard(cardId: string, customerId?: number): Promise<void> {
		const url = customerId ? this.customerCardsUrl(customerId) : this.myCardsUrl;

		return this.http.delete<void>(`${url}/${cardId}`).toPromise();
	}

	getCardsUs(customerId?: number): Promise<CustomerCard[]> {
		const url = customerId ? this.customerCardsUrl(customerId) : this.myCardsUrl;

		return this.http.get<CustomerCard[]>(this.usUrl(url)).toPromise();
	}

	addCardUs(token: string, customerId?: number): Promise<void> {
		const options = {
			headers: {
				'Content-Type': 'application/json'
			}
		};
		const url = customerId ? this.customerCardsUrl(customerId) : this.myCardsUrl;

		return this.http.post<void>(this.usUrl(url), JSON.stringify(token), options).toPromise();
	}

	deleteCardUs(cardId: string, customerId?: number): Promise<void> {
		const url = customerId ? this.customerCardsUrl(customerId) : this.myCardsUrl;

		return this.http.delete<void>(this.usUrl(`${url}/${cardId}`)).toPromise();
	}
}
